import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TExportInitialState } from "@/types/redux/exportTypes";

const initialState: TExportInitialState = {
  twitterId: "",
  mediaList: [],
  isFromGeneralPage: false,
};

const exportSlice = createSlice({
  name: "export",
  initialState,
  reducers: {
    updateTwitterId: (state, action: PayloadAction<string>) => {
      state.twitterId = action.payload;
    },
    clearMediaList: (state) => {
        state.mediaList = [];
    },
    addMediaToList: (state, action: PayloadAction<string>) => {
      state.mediaList.push(action.payload);
    },
    removeMediaFromList: (state, action: PayloadAction<string>) => {
      state.mediaList = state.mediaList.filter(
        (media) => media !== action.payload
      );
    },
    setFromGeneralPage: (state, action: PayloadAction<boolean>) => {
      state.isFromGeneralPage = action.payload;
    },
  },
});

export const {
  updateTwitterId,
  addMediaToList,
  clearMediaList,
  removeMediaFromList,
  setFromGeneralPage
} = exportSlice.actions;

export default exportSlice.reducer;
